import { render, staticRenderFns } from "./App.vue?vue&type=template&id=d84512f6"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=d84512f6&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports